import { render, staticRenderFns } from "./NaoCMS.vue?vue&type=template&id=4b8b5644"
import script from "./NaoCMS.vue?vue&type=script&lang=js"
export * from "./NaoCMS.vue?vue&type=script&lang=js"
import style0 from "./NaoCMS.vue?vue&type=style&index=0&id=4b8b5644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports